import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UtilService {
    nullIfEmpty<T>(arr: T[] | null | undefined): T[] | null {
        return arr && arr.length > 0 ? arr : null;
    }
}
